import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface AuthState {
  accessToken: string | null;
  type: "company" | "candidate" | null;
  status: boolean | null;    
  isVerified: boolean | null;     // is_active
  dataProfile: boolean | null;
  email: string | null;

  setAuth: (data: {
    accessToken: string | null;
    type: "company" | "candidate";
    status: boolean;
    isVerified: boolean;
    dataProfile: boolean;
    email: string;
  }) => void;

  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      type: null,
      status: null,
      isVerified: null,
      dataProfile: null,
      email: null,

      setAuth: (data) =>
        set({
          accessToken: data.accessToken,
          type: data.type,
          status: data.status,
          isVerified: data.isVerified,
          dataProfile: data.dataProfile,
          email: data.email,
        }),

      logout: () =>
        set({
          accessToken: null,
          type: null,
          status: null,
          isVerified: null,
          dataProfile: null,
          email: null,
        }),
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
